(() => {
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const cacheKey = 'njt-brand-fitment-v82';
  let cache = {}, generation = 0, selected = null, timer, refreshTimer, controller;
  try { cache = JSON.parse(localStorage.getItem(cacheKey) || '{}'); } catch (_) {}
  function normalize(value) {
    const text = document.createElement('textarea');
    text.innerHTML = String(value || '');
    const once = text.value;
    text.innerHTML = once;
    const name = text.value.normalize('NFKC').trim().toLocaleLowerCase().replace(/\s+/g, ' ');
    return ({'rhino-rack':'rhino rack','greentrac':'greentrac tires','lionhart':'lionhart tires','transeagle':'transeagle tires'})[name] || name;
  }
  function saved() {
    try { return JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null'); } catch (_) { return null; }
  }
  function vehicle() {
    const url = new URL(location.href);
    return url.searchParams.has(vehicleKey) ? url.searchParams.get(vehicleKey) || '' : saved()?.vehicleName || '';
  }
  function handleFor(name) {
    const option = [...document.querySelectorAll('[data-vehicle-identifier]')].find(el => el.dataset.vehicleIdentifier === name);
    if (option?.dataset.vehicleCollectionHandle) return option.dataset.vehicleCollectionHandle;
    const tile = [...document.querySelectorAll('[data-njh-vehicle]')].find(el => el.dataset.vehicleName === name);
    if (tile?.dataset.vehicleHandle) return tile.dataset.vehicleHandle;
    const stored = saved();
    return stored?.vehicleName === name ? stored.vehicleCollectionHandle || '' : '';
  }
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      document.querySelectorAll('njt-brand-carousel').forEach(el => { if (el.track) el.refreshItems(); });
      document.querySelector('#njh-brand-search')?.dispatchEvent(new Event('input', {bubbles:true}));
    }, 180);
  }
  function apply(groups, names) {
    groups.forEach(nodes => nodes.forEach(node => node.toggleAttribute('data-njb-excluded', names !== null && !names.has(normalize(node.dataset.brandName)))));
    refresh();
  }
  function status(message, retry = false) {
    document.querySelectorAll('njt-brand-carousel, #njh-brands .njh-dialog-body, .collection-list:has([data-njb-fitment])').forEach(root => {
      let line = root.querySelector('[data-njb-check-status]');
      if (!line) { line=document.createElement('p'); line.dataset.njbCheckStatus=''; line.setAttribute('role','status'); root.append(line); }
      line.textContent=message; line.hidden=!message;
      const count=root.querySelector('[data-brand-status]');
      if(count)count.hidden=Boolean(message && !retry);
      root.setAttribute('aria-busy', String(Boolean(message && !retry)));
      if (retry) {
        const button=document.createElement('button'); button.type='button';
        button.textContent=document.querySelector('[data-njb-loader]')?.dataset.retry || 'Retry';
        button.addEventListener('click',()=>{selected=null;run();},{once:true});
        line.append(' ',button);
      }
    });
  }
  async function read(handle, page, signal, name) {
    const url = new URL('/collections/'+encodeURIComponent(handle), location.origin);
    url.searchParams.set('section_id','njt-brand-fitment-index');
    url.searchParams.set('page',page);
    url.searchParams.set(vehicleKey,name);
    const current=new URL(location.href);
    ['preview_theme_id','_fd','pb'].forEach(key=>{if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));});
    for (let attempt=0;attempt<2;attempt++) {
      const requestController = new AbortController();
      const abort=()=>requestController.abort();
      signal.addEventListener('abort',abort,{once:true});
      const timeout=setTimeout(abort,15000);
      try {
        if(signal.aborted)throw Error('Cancelled');
        const response=await fetch(url,{signal:requestController.signal});
        if(!response.ok)throw Error('Unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const data=JSON.parse(doc.querySelector('[data-njb-index]')?.textContent || 'null');
        if(!data || data.collection!==handle || !Array.isArray(data.brands) || data.page!==page || !Number.isInteger(data.pages) || data.pages<1)throw Error('Invalid index');
        return data;
      } catch(error) {
        if(attempt || signal.aborted)throw error;
      } finally {clearTimeout(timeout);signal.removeEventListener('abort',abort);}
    }
  }
  async function run() {
    const next=vehicle();
    if(next===selected)return;
    selected=next;
    const version=++generation;
    controller?.abort(); controller=new AbortController();
    const signal=controller.signal;
    const groups=new Map();
    document.querySelectorAll('[data-njb-fitment]').forEach(node=>{
      const path=node.dataset.brandPath || node.getAttribute('href');
      if(!path)return;
      const url=new URL(path,location.origin);
      if(!url.pathname.includes('/collections/'))return;
      if(!groups.has(url.pathname))groups.set(url.pathname,[]);
      groups.get(url.pathname).push(node);
      const link=node.matches('a')?node:node.querySelector('a');
      if(link){const target=new URL(link.href);if(next)target.searchParams.set(vehicleKey,next);else target.searchParams.delete(vehicleKey);link.href=target.href;}
    });
    if(!next){status('');apply(groups,null);return;}
    const handle=handleFor(next);
    const hit=cache[next+'|'+handle];
    if(hit && Date.now()-hit.at<900000 && Array.isArray(hit.names)){apply(groups,new Set(hit.names));status('');return;}
    const names=new Set();
    apply(groups,names);
    status(document.querySelector('[data-njb-loader]')?.dataset.loading || '');
    try {
      if(!handle)throw Error('Missing vehicle collection');
      function accept(data) {
        if(data.vehicle!==next)throw Error('Vehicle mismatch');
        data.brands.forEach(entry=>{
          if(entry.count>0){
            (Array.isArray(entry.name)?entry.name:[entry.name]).forEach(name=>{if(name)names.add(normalize(name));});
            if(entry.vendor)names.add(normalize(entry.vendor));
          }
        });
      }
      const first=await read(handle,1,signal,next);
      if(version!==generation)return;
      accept(first);
      apply(groups,names);
      let page=2;
      async function worker() {
        while(page<=first.pages && !signal.aborted) {
          const current=page++;
          const data=await read(handle,current,signal,next);
          if(version!==generation)return;
          if(data.pages!==first.pages || data.mode!==first.mode)throw Error('Collection changed');
          accept(data);
          apply(groups,names);
        }
      }
      await Promise.all([worker(),worker(),worker()]);
      if(version!==generation)return;
      cache[next+'|'+handle]={at:Date.now(),names:[...names]};
      try{localStorage.setItem(cacheKey,JSON.stringify(cache));}catch(_){}
      apply(groups,names);status('');
    } catch(_) {
      if(version!==generation)return;
      controller.abort();
      apply(groups,names);
      status(document.querySelector('[data-njb-loader]')?.dataset.error || '',true);
    }
  }
  let active=false;
  const schedule=()=>{if(!active)return;clearTimeout(timer);timer=setTimeout(run,80);};
  const activate=()=>{active=true;schedule();};
  document.addEventListener('njt:vehicle-state',schedule);
  window.addEventListener('storage',schedule);
  window.addEventListener('popstate',schedule);
  window.addEventListener('online',()=>{selected=null;schedule();});
  document.addEventListener('shopify:section:load',()=>{selected=null;schedule();});
  function init() {
    const dialog=document.querySelector('#njh-brands');
    if(dialog){new MutationObserver(()=>{if(dialog.open)activate();}).observe(dialog,{attributes:true,attributeFilter:['open']});if(dialog.open)activate();}
    const targets=document.querySelectorAll('njt-brand-carousel,.collection-list__item[data-njb-fitment]');
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){activate();observer.disconnect();}},{rootMargin:'200px'});targets.forEach(target=>observer.observe(target));}
    else if(targets.length)activate();
    if(targets.length && vehicle()) {
      if('requestIdleCallback' in window) window.requestIdleCallback(activate,{timeout:1200});
      else setTimeout(activate,500);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
